import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTenantContext } from 'shared/contexts';
import { redirectToOldPortal } from 'shared/utils/browserCompat';
import { GlobalStyle } from 'theme';

import StatusScreen from '../StatusScreen';

interface GeneralErrorScreenProps {
    showFallbackLink?: boolean;
}

function GeneralErrorScreen({ showFallbackLink = true }: GeneralErrorScreenProps) {
    const { t } = useTranslation('errors');
    const { tenantName } = useTenantContext();

    const handleFallbackClick = () => {
        redirectToOldPortal('error-screen');
    };

    return (
        <>
            <GlobalStyle alternativeBackground />
            <StatusScreen
                variant="error"
                title={ t('general.title', { tenantName }) }
                description={ t('general.description', { tenantName }) }
            />

            { showFallbackLink && (
                <FallbackContainer>
                    <FallbackButton
                        variant="outlined"
                        color="primary"
                        onClick={ handleFallbackClick }
                    >
                        { t('general.switchToClassic') }
                    </FallbackButton>
                </FallbackContainer>
            ) }
        </>
    );
}

// ===== Styles =====
const FallbackContainer = styled('div')(({ theme }) => ({
    textAlign: 'center',
    marginTop: theme.spacing(3),
    padding: theme.spacing(2)
}));

const FallbackButton = styled(Button)(({ theme }) => ({
    minWidth: '200px',
    fontSize: '16px',
    padding: theme.spacing(1.5, 3)
}));

export default memo(GeneralErrorScreen);
